import React, { useEffect, useState } from 'react';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, FundOutlined, FolderAddOutlined } from '@ant-design/icons';

import TPortafolioMyOrganizations from './TPortafolioMyOrganizations';
import { connect } from 'react-redux';
import { getParentOrganizationsByUser, getAllOrganization, getOrganizationsByParentOrganizationId } from 'src/store/organization/thunks';
import { AppState } from 'src/store';
import TPortafolioOrganizations, { DataTypePortafolio } from './TPortafolioOrganizations';
import TActivityDataPortfolio from './TActivityDataPortfolio';
import { Button, Col, DatePicker, Form, Input, InputNumber, Popconfirm, PopconfirmProps, Row, Select, Space, Table, Tooltip } from 'antd';
import validateMessages from 'src/globals/Inputs/validateMessages';
import style from '../Tables.module.scss'
import { RequiredMark } from 'antd/es/form/Form';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateNumber } from 'src/globals/Inputs/validateInput';
import { Loan } from 'src/store/portfolio/types';
import dayjs from 'dayjs';
import { ColumnsType } from 'antd/es/table';
import { getPortfolio, postPortfolio, putPortfolio, putStatusPortfolio } from 'src/store/portfolio/thunks';
import { DataType } from './TGeiInventoryPortafolio';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
interface TPortafolioGeiProps {
    organizationData: DataTypePortafolio | undefined;
    geiPortafolio: DataType | undefined;
    getPortfolio?: any;
    postPortfolio?: any;
    putStatusPortfolio?: any;
    putPortfolio?: any

}

const TPortafolio: React.FC<TPortafolioGeiProps> = (props: TPortafolioGeiProps) => {
    const [dataTable, setDataTable] = useState([]);
    const { Option } = Select;
    const [formPortfolio] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [dataTablePortfolio, setDataTablePortfolio] = useState([]);
    const [isType, setType] = useState(true);
    const [isTypeFinancimiento, setIsTypeFinancimiento] = useState("");
    const [isLoan, setIsLoan] = useState<Loan>();
    const init = async () => {
        const response = await props.getPortfolio(props.geiPortafolio?.id);
        setDataTablePortfolio(response);
    }
    const formatCurrency = (num: number): string => {
        return new Intl.NumberFormat("es-EC", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
        }).format(num);
    };


    useEffect(() => {
        init();
    }, [props.geiPortafolio]);
    const onRegisterPortfolio = async (values: any) => {
        setType(true);
        const request = {
            Id: isLoan?.id,
            TotalAssets: values.totalAssets,
            TotalDebt: values.totalDebt,
            PendingBalance: values.pendingBalance,
            ShareBank: values.shareBank,
            ShareBankTotal: values.shareBankTotal,
            TypeFinancing: values.type,
            GeiInventoryPortafolioId: props.geiPortafolio?.id
        }
        if (isType) {
            await props.postPortfolio(request)
        } else {
            await props.putPortfolio(request)
        }
        const response = await props.getPortfolio(props.geiPortafolio?.id);
        setDataTablePortfolio(response);
        formPortfolio.resetFields();
        setIsTypeFinancimiento("")

    }
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };
    const confirm: PopconfirmProps['onConfirm'] = async (e) => {
        const request = {
            portfolioId: isLoan?.id,
            Status: "INACTIVO"
        }
        await props.putStatusPortfolio(request);
        const response = await props.getPortfolio(props.geiPortafolio?.id);
        setDataTablePortfolio(response);


    };

    const cancel: PopconfirmProps['onCancel'] = (e) => {


    };
    const [isActivityDataModal, setActivityDataModal] = useState(false);

    const handleActivityData = async (state: boolean, record: Loan) => {
        setActivityDataModal(true)
        setIsLoan(record);
    }

    const columnsLoans: ColumnsType<Loan> = [
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: 'Patrimonio Total',
            width: 30,
            dataIndex: 'totalAssets',
            key: 'totalAssets',
           render: (value: number) => formatCurrency(value),
        },
        {
            title: 'Deuda Total',
            width: 30,
            dataIndex: 'totalDebt',
            key: 'totalDebt',
            render: (value: number) => formatCurrency(value),
        },
        {
            title: 'Tipo de Préstamo',
            width: 30,
            dataIndex: 'typeFinancing',
            key: 'typeFinancing',
        },
        {
            title: 'Saldo Pendiente',
            width: 30,
            dataIndex: 'pendingBalance',
            key: 'pendingBalance',
          render: (value: number) => formatCurrency(value),
        },
        {
            title: 'Acciones Otorgadas Banco',
            width: 30,
            dataIndex: 'shareBank',
            key: 'shareBank',
            render: (value) => value ?? 'N/A',
        },
        {
            title: 'Total Acciones',
            width: 30,
            dataIndex: 'shareBankTotal',
            key: 'shareBankTotal',
            render: (value) => value ?? 'N/A',
        },
        {
            title: 'Factor Atribución',
            width: 30,
            dataIndex: 'attributionFactor',
            key: 'attributionFactor',
            render: (value) => value ?? 'N/A',
        },
        //attributionFactor
        {
            title: 'Estado',
            width: 30,
            dataIndex: 'status',
            key: 'status',
            sorter: (a: Loan, b: Loan) => a.status.localeCompare(b.status)
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 40,
            render: (record: Loan) => (
                <Space size="middle">



                    <Tooltip placement="topRight" title="Agregar data de actividad">
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleActivityData(true, record)}
                            icon={<ExperimentOutlined />}
                        />
                    </Tooltip>
                    <Tooltip placement="topRight" title="Actualizar">
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => {
                                setIsLoan(record)
                                setType(false);
                                setIsTypeFinancimiento(record.typeFinancing)
                                formPortfolio.setFieldsValue({
                                    totalAssets: record.totalAssets,
                                    totalDebt: record.totalDebt,
                                    type: record.typeFinancing,
                                    pendingBalance: record.pendingBalance,
                                    shareBank: record.shareBank,
                                    shareBankTotal: record.shareBankTotal
                                });
                            }}
                            // style={{ display: props.editView ? "none" : "inline-block" }}
                            icon={<EditOutlined />}
                        />

                    </Tooltip>
                    <Popconfirm
                        title="Eliminar portafolio"
                        description="¿Esta seguro que desea eliminar el portafolio?"
                        onConfirm={confirm}
                        onCancel={cancel}
                        okText="Si"
                        cancelText="No"
                    >
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                            onClick={() => setIsLoan(record)}

                            icon={<CloseCircleOutlined />}
                        />
                    </Popconfirm>
                </Space>

            ),
        },



    ];

    return (
        <div>
            <AdminHeader>Portafolio GEI {" " + props.organizationData?.name}</AdminHeader>
            <Form
                form={formPortfolio}
                layout="vertical"
                initialValues={{ requiredMarkValue: requiredMark }}
                requiredMark={requiredMark}
                onFinish={onRegisterPortfolio}
                onValuesChange={onFormLayoutChange}
                size={componentSize as SizeType}
            >


                <Form.Item name="totalAssets" label="Patrimonio neto total" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateNumber(value) }]}>
                    <Input placeholder="Ingresar patrimonio total" />
                </Form.Item>
                <Form.Item name="totalDebt" label="Deuda total " rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateNumber(value) }]}>
                    <Input placeholder="Ingresar deuda total" />
                </Form.Item>
                <Form.Item
                    name="type"
                    label="Tipo de financiamiento"
                    rules={[{ required: true, message: validateMessages.emptyField }]}
                >
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Ingresar tipo"
                        onChange={(value) => setIsTypeFinancimiento(value)}
                    >
                        <Option value="DEUDA">Deuda</Option>
                        <Option value="INVERSIONCAPITAL">Inversión de capital</Option>
                    </Select>
                </Form.Item>

                {isTypeFinancimiento !== "" && (
                    isTypeFinancimiento === "DEUDA" ? (
                        <Form.Item
                            name="pendingBalance"
                            label="Saldo pendiente"
                            rules={[
                                { required: true, message: validateMessages.emptyField },
                                { validator: (_, value) => validateNumber(value) }
                            ]}
                        >
                            <Input placeholder="Ingresar patrimonio total" />
                        </Form.Item>
                    ) : (
                        <>
                            <Form.Item
                                name="shareBank"
                                label="Número de acciones otorgadas al banco"
                                rules={[
                                    { required: true, message: validateMessages.emptyField },
                                    { validator: (_, value) => validateNumber(value) }
                                ]}
                            >
                                <Input placeholder="Ingresar patrimonio total" />
                            </Form.Item>

                            <Form.Item
                                name="shareBankTotal"
                                label="Número total de acciones"
                                rules={[
                                    { required: true, message: validateMessages.emptyField },
                                    { validator: (_, value) => validateNumber(value) }
                                ]}
                            >
                                <Input placeholder="Ingresar patrimonio total" />
                            </Form.Item>
                        </>
                    )
                )}






                <Form.Item>
                    <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                        {isType ? "Agregar" : "Actualizar"}
                    </Button>
                </Form.Item>

            </Form>
            <Table size="small" columns={columnsLoans} dataSource={dataTablePortfolio} scroll={{ x: 500 }} />

            <TActivityDataPortfolio organizationData={props.organizationData} showModal={isActivityDataModal} closeDrawer={() => setActivityDataModal(false)} Portfolio={isLoan}
            />


            <LoadingIndicator />
        </div>

    );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getPortfolio, postPortfolio, putStatusPortfolio, putPortfolio
})(TPortafolio);


